import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalVisualizaArchivosComponent } from './modal-visualiza-archivos.component';

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}

@Injectable({
  providedIn: 'root'
})
export class ModalVisualizaArchivosService {

  private modalService: NgbModal = inject(NgbModal);

  public preview(
    IdDocumento: string,
    mimeType: string,
    nombreSistema: string,
    downloadFile: boolean,
    isAcuerdoSISE: boolean,
    extOriginal: number,
    downloagOrg: boolean,
    isLaboral: boolean): Promise<boolean> {

    const modalRef = this.modalService.open(ModalVisualizaArchivosComponent, { size: 'xl', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.IdDocumento = IdDocumento;
    modalRef.componentInstance.mimeType = mimeType;
    modalRef.componentInstance.NombreSistema = nombreSistema;
    modalRef.componentInstance.downloadFile = downloadFile;
    modalRef.componentInstance.isAcuerdoSISE = isAcuerdoSISE;
    modalRef.componentInstance.extOriginal = extOriginal;
    modalRef.componentInstance.downloagOrg = downloagOrg;
    modalRef.componentInstance.isLaboral = isLaboral;

    return modalRef.result;
  }

}
